export default function reportData(params) {
  if (this.reportData) {
    this.reportData(params);
  }
}



// WEBPACK FOOTER //
// ../src/plugin/prototype/reportData.js